const lang = {
    en:{
        search : "Search",
        gptSearchtext : "Waht Would you like to watch today?",
    },
    hindi :{
        search : "खोज",
        gptSearchtext : "आज आप क्या देखना चाहेंगे?",
    },
    spanish :
    {
        search : "buscar",
        gptSearchtext : "¿Qué te gustaría ver hoy?",
        
    },

};
export default lang;